import { FormDataGroup } from 'src/types';

export const leadsPresupuestoPartialData = (
	isConfigure?: boolean,
	isDealer?: boolean,
): Partial<FormDataGroup> => ({
	headers: { FORM_OBJECTIVE: 'Presupuesto' },
	fields: {
		formFields: {},
		formularioFlag: 'presupuesto',
		formName: isConfigure
			? 'lead-presupuesto-configure'
			: isDealer
			? 'lead-presupuesto-dealer'
			: 'lead-presupuesto',
		formType: 'quote',
		pageCategory: 'Presupuesto',
	},
});
